{
  "title": "Provide ID Verification",
  "client": "Client",
  "relationshipTo": "Relationship to {{whom}} (primary member)",
  "continue": "Continue",
  "updated": "Household member {{memberName}} has been updated.",
  "save": "Save",
  "documentType": "Document Type",
  "methodOfIDVerification": "Method of ID Verification",
  "informationSource": "Information Source",
  "informationType": "Information Type",
  "documentID": "Document Reference Number",
  "documentIDSingle": "Document ID",
  "userName": "Name on the ID",
  "secondaryUserName": "Name on the ID",
  "informationSourceSingle": "Document Issuing Jurisdiction",
  "verifiedDate": "Verified date",
  "expiryDate": "Expiry Date",
  "nextDocument": "Next Document",
  "saveDoc1": "Save Document 1 of 2",
  "saveDoc2": "Save Document 2 of 2",
  "firstPageStepSingleMethod": "STEP 1 of 1",
  "firstPageStepDualMethod": "STEP 1 of 2",
  "secondPageStepDualMethod": "STEP 2 of 2",
  "summaryTitle": "Provide ID Verification",
  "documentName": "Document Name",
  "documentsUploaded": "2 documents uploaded",
  "documentUploaded": "1 document uploaded",
  "noDocumentUploaded": "No document uploaded",
  "noOptionsText": "Enter new jurisdiction"
}
